//--------------------------------------------------------------------------
// <copyright file="index.js" company="Microsoft">
// Copyright (c) Microsoft Corporation. All rights reserved.
// </copyright>
//--------------------------------------------------------------------------
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { initializeIcons } from '@fluentui/react/lib/Icons';
import msalInstance from './utils/msalInstance';

initializeIcons();

const root = ReactDOM.createRoot(document.getElementById('root'));
msalInstance.initialize().then(() => {
  root.render(
      <BrowserRouter>
         <App />
      </BrowserRouter>
  );
}).catch((error) => {
  console.error("MSAL initialization failed:", error);
  root.render(<div>Authentication service failed to initialize. Please refresh the page.</div>);
});
